// extracted by mini-css-extract-plugin
export var container = "FAQSection-module--container--a0692";
export var ctaWrap = "FAQSection-module--ctaWrap--e3542";
export var heading = "FAQSection-module--heading--0f0d0";
export var item = "FAQSection-module--item--2b00a";
export var itemAnswer = "FAQSection-module--itemAnswer--79b79";
export var itemArrow = "FAQSection-module--itemArrow--ce9e2";
export var itemBody = "FAQSection-module--itemBody--c341a";
export var itemBtn = "FAQSection-module--itemBtn--0829a";
export var itemOpen = "FAQSection-module--itemOpen--1b8ed";
export var itemQuestion = "FAQSection-module--itemQuestion--e97c4";
export var left = "FAQSection-module--left--27396";
export var right = "FAQSection-module--right--34db5";
export var section = "FAQSection-module--section--9fd49";
export var subtext = "FAQSection-module--subtext--b1c4d";
export var tag = "FAQSection-module--tag--da68a";